import {axiosFormDataInstance, axiosInstance} from "./axiosConfig";


export const listRoles = async (page=1,perPage=10,name='') => {
    let url = '/role?page='+page+'&per_page='+perPage;
    if(name !== ''){
        url = '/role?page='+page+'&per_page='+perPage+'&name='+name;
    }
    return axiosInstance.get(url);
};

export const viewRole = async (id) => {    
    return axiosInstance.get('/role/'+id);
};


export const listPermissions = async () => {
    return axiosInstance.get('/permission');
};
export const createRole = async (name,permissions) => {
    return axiosInstance.post('/role', {name,permissions_ids:permissions});
};

export const deleteRole = async (id) => {
    return axiosInstance.delete('/role/'+id);
};

export const updateRole = async (id,name,permissions) => {
    return axiosInstance.put('/role/'+id, {name:name,permissions_ids:permissions});
};
